export default "__VITE_ASSET__C0S567hB__"